import React from 'react';
import featureToggle from '../../../featureToggle.json';
import ClearIcon from '@mui/icons-material/Clear';
import Dev from '../../dev/Dev';
import { Flex } from '@aws-amplify/ui-react';
import { useState, useEffect, useContext } from 'react';
import { useIdleTimer } from '../../../utils/IdleTimer';
import { FiltersContext } from '../../../components/Navigation/Routes';
import { Modal, Button } from '@mui/material';
import { IconButton } from '@mui/material';
import { SigmaEmbed } from '../../../layouts/SigmaEmbed';
import { Box } from '@mui/system';
import usersService from '../../../axios/usersService';
import styles from '../reportPageHeader.module.css';
import { ContactUploadModal } from '../../../components/VendorContacts/ContactUploadModal';

export const ContactDirectory = ({ page }) => {
  const context = useContext(FiltersContext);
  const { channel, viewType, impersonatorInfo, setContactDirectoryDetails, isVendor, isBroker, vendorGroupNumber } = context;

  const [openBulkUpload, setOpenBulkUpload] = useState(false);
  const handleOpenBulkUpload = () => setOpenBulkUpload(true);
  const handleCloseBulkUpload = () => setOpenBulkUpload(false);

  const environment = process.env.REACT_APP_ENVIRONMENT;

  const [openFAQ, setOpenFAQ] = useState(false);
  const handleOpenFAQ = () => setOpenFAQ(true);
  const handleCloseFAQ = () => setOpenFAQ(false);
  const [openEditGuide, setOpenEditGuide] = useState(false);
  const handleOpenEditGuide = () => setOpenEditGuide(true);
  const handleCloseEditGuide = () => setOpenEditGuide(false);
  const [openSC] = useState(false);
  const [faqSource, setFAQSource] = useState(null);
  const [editGuideSource, setEditGuideSource] = useState(null);
  const [, setSCSource] = useState(null);

  //Handles FAQ popup
  useEffect(() => {
    const fetchFAQEmbed = async () => {
      const roleInformation =
        Object.values(impersonatorInfo).length === 0 ? {} : impersonatorInfo;
      roleInformation.view = viewType;
      const srcFAQ = await usersService.getEmbeddingUrl(
        'contact-directory-faq',
        [],
        roleInformation,
        Object.values(impersonatorInfo).length > 0,
      );
      setFAQSource(srcFAQ);
    };

    if (page === 'contact-directory') {
      fetchFAQEmbed();
    }
  }, [openFAQ, impersonatorInfo, viewType, page]);

  //Handles Edit Guide popup
  useEffect(() => {
    const fetchEditGuideEmbed = async () => {
      const roleInformation =
        Object.values(impersonatorInfo).length === 0 ? {} : impersonatorInfo;
      roleInformation.view = viewType;
      const srcEditGuide = await usersService.getEmbeddingUrl(
        'contact-directory-edit-guide',
        [],
        roleInformation,
        Object.values(impersonatorInfo).length > 0,
      );
      setEditGuideSource(srcEditGuide);
    };

    if (page === 'contact-directory') {
      fetchEditGuideEmbed();
    }
  }, [openEditGuide, impersonatorInfo, viewType, page]);

  //Handles Scoring Key popup
  useEffect(() => {
    const fetchSCEmbed = async () => {
      const roleInformation =
        Object.values(impersonatorInfo).length === 0 ? {} : impersonatorInfo;
      roleInformation.view = viewType;

      const srcSC = await usersService.getEmbeddingUrl(
        'score-card',
        [],
        roleInformation,
        Object.values(impersonatorInfo).length > 0,
      );
      setSCSource(srcSC);
    };

    if (page === 'contact-directory') {
      fetchSCEmbed();
    }
  }, [openSC, impersonatorInfo, viewType, page]);

  useEffect(() => {
    setContactDirectoryDetails(false);

    return () => setContactDirectoryDetails(false);
  }, [page, setContactDirectoryDetails]);

  useIdleTimer(channel);

  if (featureToggle[environment][page]) {
    return (
      <Flex
        direction={'column'}
        width={'100%'}
        height={'100%'}
        overflow={'hidden'}
        paddingTop={'12px'}
      >
        <Flex direction={'row'} className={styles['actions-row']}>
          <Button
            onClick={() => setContactDirectoryDetails(false)}
            className="information-buttons"
          >
            SUMMARY
          </Button>
          <Button
            onClick={() => setContactDirectoryDetails(true)}
            className="information-buttons"
          >
            Detailed Reports
          </Button>
          <Flex direction={'row'} justifyContent={'flex-end'} width={'80%'}>
            <Button onClick={handleOpenEditGuide} id="contact-directory-edit-guide-button">
              Contact Directory Edit Guide
            </Button>
            <Button onClick={handleOpenFAQ} id="contact-directory-faq-button">
              Contact Directory FAQ
            </Button>
            {(isVendor || isBroker) && featureToggle[environment]['contact-directory-bulk-upload'] && (
              <Button onClick={handleOpenBulkUpload} id="contact-directory-bulk-upload-button">
                Bulk Upload Contacts
              </Button>
            )}
            <ContactUploadModal
              open={openBulkUpload}
              onClose={handleCloseBulkUpload}
              isVendor={isVendor}
              isBroker={isBroker}
              vendorGroupNumber={vendorGroupNumber}
            />
            <Modal
              className="embed-popup"
              open={openEditGuide}
              onClose={handleCloseEditGuide}
            >
              <Box className="embed-popup-box">
                <div className="popup-close">
                  <IconButton onClick={handleCloseEditGuide}>
                    <ClearIcon color={'error'} />
                  </IconButton>
                </div>
                <iframe
                  id={'EditGuide'}
                  src={editGuideSource}
                  title={'Contact Directory Edit Guide'}
                  className="popup-iframe"
                />
              </Box>
            </Modal>
            <Modal
              className="embed-popup"
              open={openFAQ}
              onClose={handleCloseFAQ}
            >
              <Box className="embed-popup-box">
                <div className="popup-close">
                  <IconButton onClick={handleCloseFAQ}>
                    <ClearIcon color={'error'} />
                  </IconButton>
                </div>
                <iframe
                  id={'FAQ'}
                  src={faqSource}
                  title={'FAQ'}
                  className="popup-iframe"
                />
              </Box>
            </Modal>
          </Flex>
        </Flex>

        <SigmaEmbed page={page} />
      </Flex>
    );
  } else {
    return <Dev />;
  }
};
